ModalWindowConfirmService.$inject = ['ModalService'];

export function ModalWindowConfirmService(ModalService) {
  // var modalIsOpening; // for preventing double click

  var service = {
    open: openModal,
  };

  return service;

  //////////

  function openModal(modalParams, confirmCallback, cancelCallback, showRelatedTransactions) {
    // for preventing double click
    // if (modalIsOpening){ return; }
    // modalIsOpening = true;

    var modalInstance = ModalService.showModal({
      templateUrl:
        './app/ajs/_shared/services/window-modal-confirm/window-modal-confirm.service.html',
      controller: ModalWindowConfirmCtrl,
      controllerAs: 'vm',
      inputs: {
        modalParams: modalParams,
        confirmCallback: confirmCallback,
        cancelCallback: cancelCallback,
        showRelatedTransactions: showRelatedTransactions,
      },
    });

    // Register confirm and cancel callbacks
    modalInstance.then(function (modal) {
      var preventModalClose = {
        backdrop: 'static', // added static to work
        keyboard: true,
      };

      if (modalParams.preventModalClose) {
        preventModalClose.backdrop = 'static';
        preventModalClose.keyboard = false;
      }

      modal.element.modal(preventModalClose);
    });

    ModalWindowConfirmCtrl.$inject = [
      '$element',
      'UtilService',
      'modalParams',
      'confirmCallback',
      'cancelCallback',
      'showRelatedTransactions',
    ];
  }

  // Internal controller used by the modal window
  function ModalWindowConfirmCtrl(
    $element,
    UtilService,
    modalParams,
    confirmCallback,
    cancelCallback,
    showRelatedTransactions
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // If specified, fill window parameters
    vm.modalId = modalParams.id || '';
    vm.modalMode = modalParams.mode || '';
    vm.modalWidth = modalParams.width || '';
    vm.modalPosition = modalParams.position || '';
    vm.modalTitle = modalParams.title || '';
    vm.modalItemName = modalParams.itemName || '';
    vm.modalBody = modalParams.body || '';
    vm.modalReason = modalParams.reason || '';
    vm.notes = modalParams.notes || '';
    vm.requireConfirmation = modalParams.requireConfirmation || false; // this is the checkbox
    vm.confirmButtonLabel = modalParams.confirmButtonLabel || 'CONFIRM';
    vm.cancelButtonLabel = modalParams.cancelButtonLabel || 'CANCEL';
    vm.closeButtonLabel = modalParams.closeButtonLabel || 'CLOSE';

    vm.relatedTransactionButtonLabel = modalParams.relatedTransactionButtonLabel || '';
    vm.showOnlyConfirmButton = modalParams.showOnlyConfirmButton || false;

    vm.confirm = confirm;
    vm.cancel = cancel;
    vm.showRelatedTModal = showRelatedTModal;

    vm.showRelatedTransactionModal = !!showRelatedTransactions;
    vm.hideWarning = false;
    vm.showCallback = confirmCallback ? true : false;

    // Move this once we refactor angular - This should be generic
    // vm.requireEmail = modalParams.requireEmail || false;
    // vm.requireEmailModal = modalParams.requireEmailModal;
    // vm.booking = modalParams.booking;

    function confirm(isFormValid) {
      if ((vm.modalReason || vm.requireConfirmation) && !vm.confirmCheckBox) {
        return;
      }

      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      vm.sendingForm = true;

      // if (vm.confirmSendEmail) {
      //   vm.requireEmailModal(vm.booking);
      // }

      var ref = function (value) {
        // TODO: willy - check this, duplicate if,else - see sale channel deactivate
        if (value && value.then) {
          // Then this is a promise
          $element.modal('hide');

          vm.sendingForm = false;
        } else {
          $element.modal('hide');

          vm.sendingForm = false;
        }
      };

      if (vm.showRelatedTransactionModal) {
        ref(confirmCallback(vm.hideWarning));
      } else {
        ref(confirmCallback(vm.reason_status));
      }
    }

    function showRelatedTModal() {
      showRelatedTransactions(vm.hideWarning);
    }

    function cancel() {
      if (cancelCallback && cancelCallback !== undefined) {
        cancelCallback(vm.hideWarning);
      }

      $element.modal('hide');
    }
  }
}
